import Vue from 'vue'
import Router from 'vue-router'
import { hasAuthToken } from '@/utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { path: '/', name: 'home', component: () => import('@/views/HomeView') },
    { path: '/section/:id', name: 'section', component: () => import('@/views/SectionView') },
    { path: '/channel/:code?', name: 'channel', component: () => import('@/views/ChannelView') },
    { path: '/category', redirect: '/channel' },
    { path: '/search', name: 'search', component: () => import('@/views/SearchView') },
    { path: '/title/:id', name: 'title', component: () => import('@/views/TitleView') },
    { path: '/play/:episodeId', name: 'play', component: () => import('@/views/PlayView') },
    { path: '/member', name: 'member', component: () => import('@/views/MemberView') },
    { path: '/vip', redirect: '/member' },
    { path: '/login', name: 'login', component: () => import('@/views/LoginView') },
    { path: '/register', name: 'register', component: () => import('@/views/RegisterView') },
    { path: '/profile', name: 'profile', component: () => import('@/views/ProfileView'), meta: { requiresAuth: true } },
    { path: '/creator', name: 'creator', component: () => import('@/views/CreatorView'), meta: { requiresAuth: true } },
    { path: '/checkout', name: 'checkout', component: () => import('@/views/CheckoutView'), meta: { requiresAuth: true } },
    { path: '/me', redirect: '/profile' },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !hasAuthToken()) {
    next({ name: 'login', query: { redirect: to.fullPath, reason: 'required' } })
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js